import request from '@/utils/request'

// 获取配置信息
export const getConfigInfoApi = (settingKey) => request({
  url: '/setting/getSettingByKey',
  method: 'get',
  params: { settingKey }
})
// 获取用户信息
export const getUserInfoApi = () => request({
  url: '/bd/user/userInfo',
  method: 'get'
})
// 获取应用列表
export const getAppListApi = (params) => request({
  url: '/bd/operation/getUserOperation',
  method: 'get',
  params
})
// 获取提醒列表
export const getTipListApi = (params) => request({
  url: '/component/message/queryReceiversPaging',
  method: 'get',
  params
})
// 获取消息列表
export const getMsgListApi = (data) => request({
  url: '/component/message/getReceiveList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 获取常用应用
export const getCommonAppsApi = () => request({
  url: '/bd/homepage/commonApp',
  method: 'get',
  params: { flag: 1 }
})
// 记录用户点击
export const logUserClickApi = (params) => request({
  url: '/bd/homepage/userOperation',
  method: 'post',
  params
})
// 获取系统参数
export const getSystemParamApi = (userId) => request({
  url: '/bd/user/getButtJointInfo',
  method: 'get',
  params: { userId }
})
// 退出登录
export const logoutApi = () => request({
  url: '/bd/user/logout',
  method: 'get'
})